import { render, staticRenderFns } from "./navigation-bars-login.vue?vue&type=template&id=0b0bfc8a&scoped=true&"
import script from "./navigation-bars-login.vue?vue&type=script&lang=js&"
export * from "./navigation-bars-login.vue?vue&type=script&lang=js&"
import style0 from "./navigation-bars-login.vue?vue&type=style&index=0&id=0b0bfc8a&scoped=true&lang=css&"
import style1 from "./navigation-bars-login.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bfc8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VDialog,VFooter,VImg,VSpacer,VToolbarTitle})
